"use client";

import { ExpandableCaseCards } from "@/components/pages/ExpandableCaseCards";
import { SubpageChrome } from "@/components/pages/SubpageChrome";
import { SubpageContactBand } from "@/components/pages/SubpageContactBand";
import { useContent } from "@/components/site/ContentProvider";
import pageStyles from "./subpage.module.css";

type WorkPageViewProps = {
  initialCaseId?: string | null;
};

export function WorkPageView({ initialCaseId }: WorkPageViewProps) {
  const site = useContent();
  const page = site.pages.work;

  return (
    <SubpageChrome path="work">
      <div className={pageStyles.hero}>
        <span className={pageStyles.eyebrow}>{page.title}</span>
        <h1 className={pageStyles.headline}>{page.headline}</h1>
        <p className={pageStyles.subhead}>{page.subhead}</p>
      </div>

      <ExpandableCaseCards initialId={initialCaseId} />

      <SubpageContactBand band={page.band} headingId="work-band" />
    </SubpageChrome>
  );
}
